"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePopover = void 0;
var react_1 = require("react");
var key_event_1 = require("../key-event");
function usePopover(options) {
    if (options === void 0) { options = {}; }
    var _a = options.excludeTarget, excludeTarget = _a === void 0 ? false : _a, _b = options.excludePopover, excludePopover = _b === void 0 ? true : _b, initialTargetRef = options.targetRef;
    var _c = (0, react_1.useState)(false), isOpen = _c[0], setOpen = _c[1];
    var togglePopover = function () { return setOpen(function (value) { return !value; }); };
    var targetRef = (0, react_1.useRef)(initialTargetRef === null || initialTargetRef === void 0 ? void 0 : initialTargetRef.current);
    var popoverRef = (0, react_1.useRef)();
    (0, react_1.useEffect)(function () {
        if (initialTargetRef && initialTargetRef.current) {
            targetRef.current = initialTargetRef.current;
        }
    }, [initialTargetRef]);
    (0, key_event_1.useKeyEvent)('Escape', function () {
        if (isOpen) {
            setOpen(false);
        }
    }, []);
    var clickOutside = (0, react_1.useCallback)(function (event) {
        var target = event.target;
        if (!isOpen) {
            return;
        }
        if (!popoverRef.current) {
            return;
        }
        if (excludePopover && (popoverRef.current.contains(target) || popoverRef.current === target)) {
            return;
        }
        if (excludeTarget && (targetRef.current.contains(target) || targetRef.current === target)) {
            return;
        }
        setOpen(false);
    }, [isOpen, popoverRef, targetRef]);
    (0, react_1.useEffect)(function () {
        document.addEventListener('mousedown', clickOutside, { capture: true });
        document.addEventListener('touchstart', clickOutside, { capture: true });
        return function () {
            document.removeEventListener('mousedown', clickOutside, { capture: true });
            document.removeEventListener('touchstart', clickOutside, { capture: true });
        };
    }, [clickOutside]);
    return {
        isPopoverOpen: isOpen,
        togglePopover: togglePopover,
        openPopover: function () { return setOpen(true); },
        closePopover: function () { return setOpen(false); },
        targetRef: targetRef,
        popoverRef: popoverRef,
    };
}
exports.usePopover = usePopover;
//# sourceMappingURL=index.js.map